import { CheckOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import React from 'react';
import { useUser } from '../../../../hooks/use_user';
import SvgLockIcon from '../../../svg/lock_icon';
import {
  LAYER_TYPES,
  MapLayerState,
  OVERLAY_LAYER,
  OVERLAY_LAYER_INFO,
  POINTS_OF_INTEREST_LAYER,
  POINTS_OF_INTEREST_LAYER_INFO,
} from '../../map_types';
import styles from './points_of_interest_modal.less';

const pointsOfInterestNames = Object.keys(POINTS_OF_INTEREST_LAYER_INFO);

interface PointsOfInterestModalProps {
  mapLayerState: MapLayerState;
  onPointsOfInterestLayerChange: (layer: POINTS_OF_INTEREST_LAYER) => void;
  onOverlayLayersChange: (layer: OVERLAY_LAYER) => void;
  isOpen: boolean;
}

export const PointsOfInterestModal = (props: PointsOfInterestModalProps) => {
  const { mapLayerState, onPointsOfInterestLayerChange, onOverlayLayersChange, isOpen } = props;

  const { user } = useUser();

  const poisLayers = [
    OVERLAY_LAYER_INFO.PINS,
    POINTS_OF_INTEREST_LAYER_INFO.WAYPOINTS,
    POINTS_OF_INTEREST_LAYER_INFO.BOAT_LANDINGS,
  ];

  const handleLayerChange = (value: POINTS_OF_INTEREST_LAYER | OVERLAY_LAYER) => {
    if (pointsOfInterestNames.includes(value)) {
      onPointsOfInterestLayerChange(value as POINTS_OF_INTEREST_LAYER);
    } else {
      onOverlayLayersChange(value as OVERLAY_LAYER);
    }
  };

  if (!isOpen) {
    return null;
  }

  return (
    <div className={styles.modal}>
      {poisLayers.map(({ icon, name, value }) => {
        const Icon = icon;
        const isPoiLayerSelected = mapLayerState[LAYER_TYPES.POINTS_OF_INTEREST].includes(
          value as POINTS_OF_INTEREST_LAYER
        );
        const isOverlayLayerSelected = mapLayerState[LAYER_TYPES.OVERLAY].includes(
          value as OVERLAY_LAYER
        );

        const isLayerSelected = isPoiLayerSelected || isOverlayLayerSelected;
        const isWaypointLayer = value === POINTS_OF_INTEREST_LAYER_INFO.WAYPOINTS.value;

        return (
          <div
            key={name}
            className={classNames(styles.layerItem, {
              [styles.layerItem__selected]: isLayerSelected,
            })}
            onClick={() => handleLayerChange(value as POINTS_OF_INTEREST_LAYER | OVERLAY_LAYER)}
          >
            {isWaypointLayer && !user ? (
              <span className={classNames(styles.lockIcon, 'color-[#657d7d]')}>
                <SvgLockIcon />
              </span>
            ) : (
              <span
                className={classNames(styles.checkmark, {
                  [styles.checkmark__selected]: isLayerSelected,
                })}
              >
                <CheckOutlined />
              </span>
            )}
            <span className={styles.label}>{name}</span>
            <input
              type="radio"
              id={name}
              checked={isLayerSelected}
              name="pois_and_overlays"
              value={value}
              onChange={() => handleLayerChange(value as POINTS_OF_INTEREST_LAYER | OVERLAY_LAYER)}
              hidden
            />
            <span className={styles.layerIcon}>
              <Icon />
            </span>
          </div>
        );
      })}
    </div>
  );
};
